module.exports = __webpack_public_path__ + "img/phone.57c2accb.svg";